export default function (isPublic: boolean) {
  return isPublic ? "Internal + Marketplace" : "Internal";
}

export const getPostedAt = (isPublic: boolean) => {
  return isPublic ? ["Internal", "Marketplace"] : ["Internal"];
};
